import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import RoleSwitcher from './auth/RoleSwitcher';
import { useAuth } from '../context/AuthContext';

const { FiBell, FiLogOut } = FiIcons;

const PAGE_TITLES = {
  '/': { title: 'Dashboard' },
  '/learners': { title: 'Learners' },
  '/employees': { title: 'Employees' },
  '/campaigns': { title: 'Training Campaigns' },
  '/phishing': { title: 'Phishing Simulations' },
  '/library': { title: 'Training Library' },
  '/reports': { title: 'Reports' },
  '/compliance': { title: 'Compliance' },
  '/notifications': { title: 'Notifications' },
  '/remediation': { title: 'Remediation' },
  '/settings': { title: 'Settings' },
  '/roles': { title: 'Role Management' },
  '/employee/dashboard': { title: 'Dashboard' },
  '/employee/my-history': { title: 'My History' },
  '/employee/settings': { title: 'Settings' },
  '/my-team': { title: 'My Team' },
};

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();
  
  // Try exact match first, fallback to base route match
  const exactPath = location.pathname;
  const base = '/' + location.pathname.split('/')[1];
  const info = PAGE_TITLES[exactPath] || PAGE_TITLES[base] || { title: 'Sentinel' };

  // Safeguard against missing user context
  if (!currentUser) return null;

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-4 md:px-8 sticky top-0 z-10">
      <div>
        <h1 className="text-sm font-medium text-slate-600 leading-tight truncate max-w-[120px] sm:max-w-xs">{info.title}</h1>
      </div>
      <div className="flex items-center gap-2 sm:gap-4">
        <span className="hidden sm:inline-block px-3 py-1 bg-red-50 text-red-600 border border-red-100 rounded text-xs font-semibold">
          {currentUser.role}
        </span>
        <button className="relative w-9 h-9 flex items-center justify-center rounded-lg text-slate-500 hover:bg-slate-100 transition-colors">
          <SafeIcon icon={FiBell} className="text-lg" />
          <span className="absolute top-2 right-2 w-2 h-2 bg-red-500 rounded-full border-2 border-white" />
        </button>
        <div className="w-px h-6 bg-slate-200 mx-1 sm:mx-0" />
        <RoleSwitcher />
        <button 
          onClick={handleLogout}
          title="Sign Out"
          className="w-9 h-9 flex items-center justify-center rounded-lg text-slate-500 hover:bg-red-50 hover:text-red-600 transition-colors"
        >
          <SafeIcon icon={FiLogOut} className="text-lg" />
        </button>
      </div>
    </header>
  );
};

export default Header;